import TldlEpisodesCard from './TldlEpisodesCard';

export default TldlEpisodesCard;
